<template>
  <div class="pigeondoc__placeholder" :style="{ height: value.meta.height + 'px' }"></div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'Placeholder',
  props: {
    value: PigeonDocNodeModel,
  },
};
</script>

<style>
.pigeondoc__placeholder {
  background-color: #eee;
}
</style>
